// import Vue from 'vue'

export default class FormWidgetSubmitService{

    constructor(id, language = false){
        this.id = id
        this.api = '/api/forms/' + id + '/submit';
        if(language)
            this.api += '?language=' + language

        this.queryString = {}
    }

    store(model, success, error = null){

        Vue.http.post(this.api , model).then(function (response) {
            success(response.data)

        }, function(response){
            if( ! _.isNull(error))
                error(response)
            else
                console.log(response)
        });
    }

    update(id, model, success, error = null){
        Vue.http.put(this.api + '/' + id, model).then(function (response) {
            success(response.data)

        }, function(response){
            if( ! _.isNull(error))
                error(response)
            else
                console.log(response)
        });
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/ui/src/core/site/forms/core/FormWidgetSubmitService.js